import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CommonLoader from '../../../../components/common-loader/CommonLoader';
import CommonPagination from '../../../../components/common-pagination/CommonPagination';
import { PROMPT_TYPE } from '../../../../constants';
import EmptyMessagesList from '../../../../genie/components/messages-list/EmptyMessagesList';
import { changeImagesTable } from '../../../../redux/id8/id8Reducer';
import FrameCard from '../card/FrameCard';
import PhotoPreview from '../photo-preview/PhotoPreview';
import { useProject } from '../../../../context/ProjectContext';
import imageReactionHelper from '../../../utils/imageReactionHelper';

import scss from './FrameOutput.module.scss';

function FrameOutput() {
  const dispatch = useDispatch();
  const [imagesPreview, setImagesPreview] = useState(null);

  const { actions } = useProject();

  const imagesContent = useSelector((state) => state.id8.imagesContent);
  const { page, size, totalElements } = useSelector((state) => state.id8.imagesTableSettings);
  const isImagesLoading = useSelector((state) => state.id8.isImagesLoading);

  const handleClosePreview = () => {
    setImagesPreview(null);
  };

  const handleOpenPreview = ({ frameData, initialIndex }) => {
    setImagesPreview({ frameData, initialIndex });
  };

  const handleLike = (likedImage) => {
    const { newReaction, newUpdatedOn, previewCallback } = imageReactionHelper(likedImage);
    actions('likeImage', {
      imageId: likedImage.id,
      newReaction,
      updatedOn: newUpdatedOn,
      promptType: PROMPT_TYPE.IDEA,
    });

    // if (imagesPreview) {
    //   setImagesPreview(previewCallback);
    // }
  };

  const handleDownload = (id) => {
    actions('downloadImage', id);
  };

  const handleChangePage = (newPage) => {
    dispatch(changeImagesTable({ page: newPage + 1 }));
  };

  const handleRevise = async (values) => {
    await actions('reviseImage', values);
  };

  useEffect(() => {
    if (imagesPreview) {
      const updatedFrameData = imagesContent.find((frame) => frame.id === imagesPreview.frameData.id);
      if (updatedFrameData) {
        setImagesPreview((prev) => ({
          ...prev,
          frameData: updatedFrameData,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imagesContent]);

  return (
    <div className={scss.wrapper}>
      {!isImagesLoading && imagesContent.length === 0 ? (
        <EmptyMessagesList />
      ) : (
        <div className={scss.cardsWrapper}>
          {imagesContent.map((frameData) => (
            <FrameCard
              key={frameData.id}
              frameData={frameData}
              onPreview={handleOpenPreview}
              onDownload={handleDownload}
              onLike={handleLike}
            />
          ))}
        </div>
      )}

      <CommonPagination
        activePage={page - 1}
        itemsPerPage={size}
        totalItemsCount={totalElements}
        onChangePage={handleChangePage}
      />

      <CommonLoader isLoading={isImagesLoading} />

      <PhotoPreview
        isOpen={imagesPreview}
        onClose={handleClosePreview}
        imagePreview={imagesPreview}
        onDownload={handleDownload}
        onLike={handleLike}
        onRevise={handleRevise}
      />
    </div>
  );
}

export default FrameOutput;
